import { ArrowLeftOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { LinkProps, useNavigate } from 'react-router-dom';
import { Button, COLOR_BASE_500, useTheme } from '..';

interface BackButtonProps extends LinkProps {
  buttonText?: string;
  className?: string;
  'data-testid'?: string;
  primary?: boolean;
}

export const BackButton = ({
  to,
  buttonText,
  primary = true,
  className,
  relative,
  'data-testid': testId,
}: BackButtonProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { textColor } = useTheme();

  return (
    <Button
      icon={<ArrowLeftOutlined />}
      type="text"
      onClick={() => navigate(to, { relative })}
      data-testid={testId}
      className={cx('text-base-600 px-1 w-fit mb-2 text-sm md:text-base', className)}
      style={{ color: primary ? textColor : COLOR_BASE_500 }}
    >
      {buttonText ?? t('common.back_to_search')}
    </Button>
  );
};
